import React from 'react';
import _ from 'lodash';

import { BaseWidget } from 'modules/layer01';
import { Table } from 'iron-forge-react-modules';
import * as dataService from './dataService';
import * as types from './types';
import { currencyUtil } from 'modules/layer00';



const TableComponent = Table.genTableComponent<types.IColumnId>();



export interface IProps {
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);



  const rows = React.useMemo(
    () => _.map(queryTuple.data.rules, (rule): types.IRow => ({
      id: rule.id,
      columnId2Value: {
        comparisonOperator: {
          type: 'string',
          label: rule.comparisonOperator
        },
        productName: {
          type: 'string',
          label: rule.productName
        },
        productPrice: {
          type: 'string',
          label: currencyUtil.convertBigCentsToDollars(rule.priceCents)
        },
        sku: {
          type: 'string',
          label: rule.sku
        },
        value: {
          type: 'string',
          label: rule.value
        }
      }
    })),
    [queryTuple.data.rules]
  );

  return (
    <BaseWidget.FC title="Line Item Unbundling Rules">
      <TableComponent
        disableSorting
        rows={rows}
        columns={[
          {
            id: 'comparisonOperator',
            label: "Operator"
          },
          {
            id: 'value',
            label: "Metadata Value"
          },
          {
            id: 'sku',
            label: "SKU"
          },
          {
            id: 'productName',
            label: "Product Name"
          },
          {
            id: 'productPrice',
            label: "Product Price"
          }
        ]} />
    </BaseWidget.FC>
  );
};
